import script from "./transactions.vue?vue&type=script&setup=true&lang=js"
export * from "./transactions.vue?vue&type=script&setup=true&lang=js"

import "./transactions.vue?vue&type=style&index=0&id=98a8106a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98a8106a"]])

export default __exports__